import React, {useEffect, useState} from 'react';
import {Backdrop, IconButton} from '@mui/material';
import {Close} from '@mui/icons-material';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import {useParams} from 'react-router';
import {VideoEmbedStaige} from 'app/components/videoEmbeeds/StaigeEmbed';
import {VideoEmbedYoutube} from 'app/components/videoEmbeeds/YoutubeEmbed';
import {VideoEmbedSporttotal} from 'app/components/videoEmbeeds/SporttotalEmbed';
import {VideoEmbedOneFootball} from 'app/components/videoEmbeeds/OneFootballEmbed';
import {zIndexBackdrop} from 'app/styles/cssConstants';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ButtonContainer = styled.div`
  width: 100%;
  height: ${SIZES['40']};
  @media only screen and (orientation: portrait) {
    padding-top: ${SIZES['24']};
    height: ${SIZES['64']};
  }
`;

const VideoContainer = styled.div`
  height: calc(100% - ${SIZES['40']});
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (orientation: portrait) {
    height: calc(100% - ${SIZES['64']});
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  height: calc(100vw * 9 / 16);
  aspect-ratio: 16/9;
  @media (min-aspect-ratio: 16/9) {
    width: auto;
    height: 100%;
  }
`;

const EmbeddedVideo = ({entity, open, onClose}) => {
  const [ssrRender, setSsrRender] = useState(typeof window === 'undefined');
  const {matchSlug} = useParams();
  useEffect(() => {
    setSsrRender(false);
  }, []);

  const videoProvider = {
    Staige: open =>
      open ? (
        <VideoEmbedStaige
          isHydrationFinished={!ssrRender}
          id={entity.uniqueId}
          source={entity.source}
          videoUrl={entity.url}
          matchSlug={matchSlug}
          playlistId={entity.id}
        />
      ) : null,
    YouTube: open => (
      <VideoEmbedYoutube
        isHydrationFinished={!ssrRender}
        id={entity.uniqueId}
        source={entity.source}
        videoUrl={entity.url}
        matchSlug={matchSlug}
        open={open}
        playlistId={entity.id}
      />
    ),
    Sporttotal: () => <VideoEmbedSporttotal id={entity.uniqueId} />,
    oneFootball: () => (
      <VideoEmbedOneFootball
        id={entity.uniqueId}
        source={entity.source}
        matchSlug={matchSlug}
        isHydrationFinished={!ssrRender}
        playlistId={entity.id}
      />
    ),
  };

  if (!(entity.source in videoProvider)) {
    return null;
  }

  return (
    <Backdrop
      sx={{zIndex: zIndexBackdrop, backgroundColor: COLORS.black, width: '100%', height: '100%', bottom: 'unset'}}
      open={!!open}>
      <Container>
        <ButtonContainer>
          <IconButton sx={{marginLeft: SIZES['24'], left: 0, top: 0}} onClick={onClose}>
            <Close sx={{color: COLORS.white, fontSize: 24}} />
          </IconButton>
        </ButtonContainer>
        <VideoContainer>
          <VideoWrapper>{videoProvider[entity.source](open)}</VideoWrapper>
        </VideoContainer>
      </Container>
    </Backdrop>
  );
};

export {EmbeddedVideo};
